<template>
  <div class="container-forms">
    <p>
      Crea formularios asociados a una tipificación. Son ideales para guardar datos asociados a una
      gestión.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>

    <div class="filter">
      <a-form>
        <a-form-item>
          <a-input
            v-model:value="search"
            placeholder="Buscar..."
            class="form__input"
            @input="handleSearchEntities"
          >
            <template #prefix>
              <SearchOutlined />
            </template>
          </a-input>
        </a-form-item>
      </a-form>
    </div>

    <div class="forms">
      <FormCard create @create="handleOpenCreateModal" />

      <FormCard
        v-for="form in formData"
        :key="form.id"
        :id="form.id"
        :name="form.name"
        :description="form.description"
        :count="form.total_links"
        @delete="handleDelete(form)"
      />
    </div>

    <CreateModal v-model:visible="createModalVisible" />
  </div>

  <RestrictionChangePlanModal
    title="¡Alcanzaste el límite de tu plan! Personalízalo y continúa tu viaje estelar."
    v-model:open="openRestriction"
    showAlert
  >
    <template #body>
      <p>
        Tu plan {{ PlanTypeText[plan] }} permite hasta 
        <span style="font-weight: 500">
          {{ limitForms }} formularios.
        </span> <br/>
        Solicita personalizar tu plan para potenciar tu ambiente de trabajo.
      </p>
      <p>
        {{
          isClientBeexcc 
          ? "Cuenta con nosotros para elevar tu experiencia. Estamos listos para asistirte. ✨"
          : "Aprovecha al máximo todo lo que puedes lograr con BeexCC. ¡Lleva tu experiencia más lejos! ✨"
        }}
      </p>
    </template>
  </RestrictionChangePlanModal>
</template>

<script>
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { SearchOutlined } from "@ant-design/icons-vue";
import { message, Modal } from "ant-design-vue";

import { formService } from "@/app/entities/services";

import FormCard from "../card/FormCard.vue";
import CreateModal from "../modals/forms/CreateModal.vue";
import { planConfigServices } from "@/app/common/services/PlanConfigServices";
import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import { PlanTypeText } from "@/app/common/types";
import { watch } from "vue";

export default {
  components: {
    FormCard,
    SearchOutlined,
    CreateModal,
    RestrictionChangePlanModal,
  },

  async setup() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/formularios/`;

    const store = useStore();

    const search = ref("");

    const user = computed(() => store.getters["getDataUser"]);

    const openRestriction = ref(false);
    const isClientBeexcc = computed(() => user.value?.is_beexcc);
    const dataPlan = computed(() => store.getters["getDataPlanDetails"]);

    const limitForms = computed(() => {
      const creatingForms = dataPlan.value?.configuration.creating_forms;
      return creatingForms?.unlimited ? true : creatingForms?.value;
    });
    const plan = computed(() => user.value?.change_custom_plan?.plan);
    store.dispatch("getFormsTypifications");

    const formattedFormsList = computed(() => store.getters.getForms);

    const previewModalData = ref({
      visible: false,
      type: null,
      title: null,
    });

    const handleDelete = async (form) => {
      console.log(form);

      Modal.confirm({
        title: `¿Estás seguro de eliminar ${form.name}?`,
        content: "Eliminar",
        centered: true,
        onOk: async () => {
          try {
            await formService.delete(form.id);
            await store.dispatch("getFormsTypifications");

            message.success(`Se eliminó ${form.name}`);
          } catch (error) {
            message.error("No se pudo eliminar");
          }
        },
      });
    };

    const onClose = () => {
      previewModalData.value.visible = false;
    };

    const createModalVisible = ref(false);

    const handleOpenCreateModal = () => {
      if (limitForms.value == true || formattedFormsList.value?.length < limitForms.value)
        createModalVisible.value = true;
      else
        openRestriction.value = true;
    };

    return {
      search,
      previewModalData,
      formData: computed(() =>
        formattedFormsList.value.filter((form) =>
          form.name.toLowerCase().includes(search.value.toLowerCase())
        )
      ),
      onClose,
      createModalVisible,
      handleOpenCreateModal,
      handleDelete,
      DOCS_URL,
      limitForms,
      dataPlan,
      openRestriction,
      formattedFormsList,
      plan,
      PlanTypeText,
    };
  },
};
</script>

<style lang="sass" scoped>
.container-forms
  padding: 8px 20px

.filter
  display: flex
  justify-content: space-between
  margin-top: 12px

.form__input
  width: 380px

.forms
  gap: 12px
  display: grid
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))
</style>
